import { convertDigitToProperFormat } from '../../utils/number';
import i18n from '../../i18n';

export default {
  search: 'جستجو',
  thereIsNoMatchedItem: 'موردی پیدا نشد',
  confirm: 'تأیید',
  cancel: 'لغو',
  youCanOnlyChooseOneUser: 'شما فقط می‌توانید یک کاربر انتخاب کنید',
  inactiveUser: 'کاربر غیر فعال',
  name: 'نام',
  phone: 'شماره تلفن',
  phonePlaceHolder: '09123456789',
  addUser: 'افزودن کاربر',
  pleaseFillCorrectPhone: 'لطفا مقدار درستی برای شماره تلفن کاربر وارد کنید',
  pleaseFillUserName: 'لطفا نام کاربر را وارد کنید',
  selectUser: 'انتخاب فرد',
  errorAddingUser: 'شما دسترسی لازم برای دعوت از کاربر جدید را ندارید',
  invite: 'دعوت از فرد خارج از سازمان',
  showMembers: 'نمایش اعضا',

  projectMember: (projectName?: string) => {
    return i18n.t('projectMember', { ns: 'general', projectName });
  },
  persons(length: number) {
    return i18n.t('persons', {
      ns: 'general',
      length: convertDigitToProperFormat(length),
    });
  },
  memberAdded(name: string) {
    return i18n.t('memberAdded', { ns: 'general', name });
  },
};
